import { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "@/lib/tournaments";

export default function PhotoGallery({ photos }) {
  const [idx, setIdx] = useState(null);
  useEffect(() => {
    if (idx === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIdx(null);
      if (e.key === "ArrowRight") setIdx((i) => (i + 1) % photos.length);
      if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + photos.length) % photos.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx, photos.length]);

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="photo-gallery">
        {photos.map((p, i) => (
          <button key={p.id} onClick={() => setIdx(i)} data-testid={`photo-${p.id}`} className="group relative aspect-square overflow-hidden rounded-2xl bg-slate-100">
            <img src={fileUrl(p.url)} alt={p.caption || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            {p.caption && <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent text-white text-xs p-2 text-left line-clamp-2">{p.caption}</span>}
          </button>
        ))}
      </div>
      {idx !== null && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" onClick={() => setIdx(null)} data-testid="lightbox">
          <button className="absolute top-4 right-4 text-white/80 hover:text-white" data-testid="lightbox-close"><X className="h-7 w-7" /></button>
          <button className="absolute left-3 text-white/80 hover:text-white p-2" onClick={(e) => { e.stopPropagation(); setIdx((idx - 1 + photos.length) % photos.length); }} data-testid="lightbox-prev"><ChevronLeft className="h-8 w-8" /></button>
          <img src={fileUrl(photos[idx].url)} alt="" className="max-h-[90vh] max-w-[92vw] object-contain" onClick={(e) => e.stopPropagation()} />
          <button className="absolute right-3 text-white/80 hover:text-white p-2" onClick={(e) => { e.stopPropagation(); setIdx((idx + 1) % photos.length); }} data-testid="lightbox-next"><ChevronRight className="h-8 w-8" /></button>
          {photos[idx].caption && <div className="absolute bottom-6 inset-x-0 text-center text-white/90 text-sm px-6">{photos[idx].caption}</div>}
        </div>
      )}
    </>
  );
}
